import { StyleSheet, Text, View } from '@react-pdf/renderer'
import { ReportLabelInspectionArea } from '@ulysses-inc/harami_api_client'
import { getAreaDisplayValues } from 'src/features/labelCheck/components/LabelCheckAnswer/getAreaDisplayValues'
import { labelAreaResultStatusLabel } from 'src/features/labelCheck/constants/labelAreaResult'

const styles = StyleSheet.create({
  container: {
    margintTop: 8,
  },
  row: {
    paddingVertical: 1,
    paddingHorizontal: 2,
  },
  label: {
    borderRadius: 2,
  },
})

type StatusDisplayProps = {
  areas: ReportLabelInspectionArea[]
}

export const StatusDisplay = ({ areas }: StatusDisplayProps) => {
  return (
    <View style={styles.container}>
      {areas.map(area => {
        const valueText = getValueText(area)
        return (
          <View key={area.labelInspectionAreaId} style={styles.row}>
            <Text style={styles.label}>
              {labelAreaResultStatusLabel[area.status]} : {area.name}
            </Text>
            {valueText !== null && <Text>{valueText}</Text>}
          </View>
        )
      })}
    </View>
  )
}

const getValueText = (area: ReportLabelInspectionArea): string | null => {
  const displayValues = getAreaDisplayValues(area)
  switch (displayValues.kind) {
    case 'matching':
      return `（正解値: ${displayValues.matchingValue} 読取値: ${displayValues.extractedValue}）`
    case 'extractedOnly':
      return `（読取値: ${displayValues.extractedValue}）`
    case 'none':
      return null
  }
}
